import { Container, Brand, Icon, Name, Background, Join, Auth } from "./styles";
import logo from "../../../assets/brand/logo.svg";
import icon from "../../../assets/brand/icon.svg";

const Navigation = ({ hide }) => {
  return (
    <Container>
      <Brand to="/">
        <Background>
          <Icon src={icon} />
        </Background>
        <Name src={logo} />
      </Brand>
    </Container>
  );
};

export default Navigation;
